import { Component, OnInit, Input } from '@angular/core';
import { Consultant } from '../../../../models/Consultant.model';
import { ArchiveService } from '../../../../services/archive/archive.service';
import { Archive } from '../../../../models/archive/archive.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-archive-details',
  templateUrl: './archive-details.component.html',
  styleUrls: ['./archive-details.component.css']
})
export class ArchiveDetailsComponent implements OnInit {

  archive: Archive
  constructor(private archiveService: ArchiveService,
              private route: ActivatedRoute) { }

  async ngOnInit() {
    let response = await this.archiveService.get(`_id=${this.route.snapshot.params['id']}`);
    if(response.length > 0)
      this.archive = response[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/views/archive/archive/archive-details/archive-details.component.ts